import React from 'react';

export const HeaderPreview = ({ component, onClick, isSelected }) => {
  const { commonAttrs, specificAttrs } = component;
  const { text, level, fontSize, fontWeight, color, alignment } = specificAttrs || {};
  const HeadingTag = level || 'h2';
  
  const containerStyle = {
    padding: `${commonAttrs?.paddingTop || 16}px ${commonAttrs?.paddingRight || 16}px ${commonAttrs?.paddingBottom || 16}px ${commonAttrs?.paddingLeft || 16}px`,
    margin: `${commonAttrs?.marginTop || 8}px ${commonAttrs?.marginRight || 0}px ${commonAttrs?.marginBottom || 8}px ${commonAttrs?.marginLeft || 0}px`,
    width: commonAttrs?.width === 'auto' ? 'auto' : `${commonAttrs?.width || 100}%`,
    cursor: onClick ? 'pointer' : 'default',
    border: isSelected ? '2px solid #3B82F6' : '2px solid transparent',
    borderRadius: '4px'
  };
  
  return (
    <div style={containerStyle} onClick={onClick}>
      {React.createElement(HeadingTag, {
        style: {
          fontSize: `${fontSize || 24}px`,
          fontWeight: fontWeight || 'bold',
          color: color || '#1E293B',
          textAlign: alignment || 'left',
          margin: 0
        }
      }, text || 'Header Text')}
    </div>
  );
};
